import React, { useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { roleContext, LanguageContext } from "../../../libs/context";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import "./styles.css";

function CoursesMenu(props) {
  const { isOpen, onClose } = props;

  const role = useContext(roleContext);
  const language = useContext(LanguageContext);
  const location = useLocation();

  const handleItemClick = () => {
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="profile-menu-overlay" onClick={onClose} />

      <div className="profile-menu">
        <div className="profile-menu-header">
          <h3>{language.courses || "Courses"}</h3>
          <IconButton onClick={onClose} size="small" aria-label="close">
            <CloseIcon />
          </IconButton>
        </div>

        <div className="profile-menu-items">
          <NavLink
            to="/admin/class-management"
            className={({ isActive }) =>
              isActive ? "profile-menu-item active" : "profile-menu-item"
            }
            onClick={handleItemClick}
          >
            <img
              src="/images/icons/classes.png"
              alt="Classes"
              className="menu-item-icon"
            />
            <span>{language.classes || "Classes"}</span>
          </NavLink>

          <NavLink
            to="/admin/classmanagement/quesstionare"
            className={({ isActive }) =>
              isActive ? "profile-menu-item active" : "profile-menu-item"
            }
            onClick={handleItemClick}
          >
            <img
              src="/images/blue/questionnaire.png"
              alt="Questionnaire"
              className="menu-item-icon"
            />
            <span>{language.questionnaire || "Questionnaire"}</span>
          </NavLink>

          <NavLink
            to="/admin/classmanagement/assignment"
            className={({ isActive }) =>
              isActive ? "profile-menu-item active" : "profile-menu-item"
            }
            onClick={handleItemClick}
          >
            <img
              src="/images/blue/no-assignment.png"
              alt="Assignments"
              className="menu-item-icon"
            />
            <span>{language.assignments || "Assignments"}</span>
          </NavLink>
        </div>
      </div>
    </>
  );
}

export default CoursesMenu;
